import Vue from 'vue';
import Vuex from 'vuex';
import Toasted from 'vue-toasted';
import store from '../store';
import '../utils/firebase';
import AdmissionList from '../components/AdmissionList.vue';
import ActionCableStatus from '../components/ActionCableStatus.vue';
import AdmissionTicketTypeList from '../components/AdmissionTicketTypeList';
import PerformerEventsShow from '../components/PerformerEventsShow.vue';
import PerformerEventsFollowShow from '../components/PerformerEventsFollowShow.vue';
import EventLiveChat from '../components/EventLiveChat.vue';
import EventLiveDonation from '../components/EventLiveDonation.vue';
import EventLiveCurtainButton from '../components/EventLiveCurtainButton.vue';
import EventLiveCurtain from '../components/EventLiveCurtain.vue';
import EventLiveDonationItemList from '../components/EventLiveDonationItemList.vue';
import EventLiveDonatedItemList from '../components/EventLiveDonatedItemList.vue';
import EventLiveEventerMessageList from '../components/EventLiveEventerMessageList.vue';
import EventLiveEventerMessageForm from '../components/EventLiveEventerMessageForm.vue';
import EventLiveMuptipleViewing from '../components/EventLiveMuptipleViewing.vue';
import PerformerExperimentalShow from '../components/PerformerExperimentalShow.vue';
import Loading from '../components/Loading.vue';
import AudienceList from '../components/AudienceList.vue';
import SearchFormBox from '../components/SearchFormBox.vue';
import PaymentSearchCheckboxes from '../components/PaymentSearchCheckboxes.vue';
import AudienceListTable from '../components/AudienceListTable.vue';
import Paginate from 'vuejs-paginate';
import PaymentSearchModal from '../components/PaymentSearchModal.vue';
import ConfirmModalForFile from '../components/ConfirmModalForFile.vue';
import EditAudienceModal from '../components/EditAudienceModal.vue';
import RefundAudienceModal from '../components/RefundAudienceModal.vue';
import BlockAudienceModal from '../components/BlockAudienceModal.vue';
import InvalidateAudienceModal from '../components/InvalidateAudienceModal.vue';
import CancelAudienceModal from '../components/CancelAudienceModal.vue';
import OperationUnavailableModal from '../components/OperationUnavailableModal.vue';
import AdmissionListForMultiplePlayDateEvent from '../components/AdmissionListForMultiplePlayDateEvent.vue';
import AudienceListTableForMultiplePlayDateEvent from '../components/AudienceListTableForMultiplePlayDateEvent.vue';
import ActionCableStatusForMultiplePlayDateEvent from '../components/ActionCableStatusForMultiplePlayDateEvent.vue';

// components登録
Vue.component('admisiion-ticket-type-list', AdmissionTicketTypeList);
Vue.component('loading', Loading);
Vue.component('search-form-box', SearchFormBox);
Vue.component('payment-search-checkboxes', PaymentSearchCheckboxes);
Vue.component('audience-list-table', AudienceListTable);
Vue.component('paginate', Paginate);
Vue.component('payment-search-modal', PaymentSearchModal);
Vue.component('confirm-modal-for-file', ConfirmModalForFile);
Vue.component('edit-audience-modal', EditAudienceModal);
Vue.component('refund-audience-modal', RefundAudienceModal);
Vue.component('block-audience-modal', BlockAudienceModal);
Vue.component('invalidate-audience-modal', InvalidateAudienceModal);
Vue.component('cancel-audience-modal', CancelAudienceModal);
Vue.component('operation-unavailable-modal', OperationUnavailableModal);
Vue.component('audience-list-table-for-multiple-play-date-event', AudienceListTableForMultiplePlayDateEvent);
Vue.component('actioncable-status', ActionCableStatusForMultiplePlayDateEvent);

Vue.use(Vuex);
// Toastedのオプションを設定
var toastedOptions = {
  theme: 'bubble',
  position: 'bottom-right',
  className: 'tooastedOption',
  singleton: true,
  duration: 2000,
};
Vue.use(Toasted, toastedOptions);

const debug = process.env.NODE_ENV !== 'production';

document.addEventListener('DOMContentLoaded', () => {
  var path = location.pathname.split('/')[1];

  if (location.pathname.indexOf('admission') > 0 && !location.pathname.includes('/audience_list_admission')) {
    // 参加者リスト
    new Vue({
      el: '#admission-list',
      store,
      template: '<AdmissionList/>',
      components: { AdmissionList },
      render: function (createElement) {
        return createElement('AdmissionList', {
          props: {
            // propsを整形しつつComponentへ渡す
            program_id: Number(this.$el.getAttribute('program_id')),
            t: this.$el.getAttribute('t'),
            ticket_types: JSON.parse(this.$el.getAttribute('ticket_types')),
            can_action_cable: this.$el.getAttribute('can_action_cable') == 'true',
            get_audiences_path: this.$el.getAttribute('get_audiences_path'),
            admission_accept_path: this.$el.getAttribute('admission_accept_path'),
            admission_unaccept_path: this.$el.getAttribute('admission_unaccept_path'),
            event_questionnaires: JSON.parse(this.$el.getAttribute('event_questionnaires')),
            use_introducer_tell: this.$el.getAttribute('use_introducer_tell') == 'true',
            use_introducer_name: this.$el.getAttribute('use_introducer_name') == 'true',
            use_introducer_adress: this.$el.getAttribute('use_introducer_adress') == 'true',
            is_giants_user: this.$el.getAttribute('is_giants_user') == 'true',
            is_assistant_page: this.$el.getAttribute('is_assistant_page')
          },
        });
      },
    }),
      // actioncableのステータス表示
      new Vue({
        el: '#actioncable-status',
        store,
        template: '<ActionCableStatus/>',
        components: { ActionCableStatus },
        render: function (createElement) {
          return createElement('ActionCableStatus', {
            props: {},
          });
        },
      });
  }

  if (location.pathname.match(/audience_list$/)) {
    // 通し券イベント参加者リスト
    new Vue({
      el: '#audience-list-container',
      store,
      template: '<AudienceList/>',
      components: { AudienceList },
      render: function (createElement) {
        return createElement('AudienceList', {
          props: {
            main_event_id: Number(this.$el.getAttribute('main_event_id')),
            main_event_title: String(this.$el.getAttribute('main_event_title')),
            play_dates: JSON.parse(this.$el.getAttribute('play_dates')),
            ticket_types: JSON.parse(this.$el.getAttribute('ticket_types')),
            ticket_types: JSON.parse(this.$el.getAttribute('ticket_types')),
            get_audiences_path: this.$el.getAttribute('get_audiences_path'),
            event_use_introducer: this.$el.getAttribute('event_use_introducer') == 'true',
            event_introducer_text: this.$el.getAttribute('event_introducer_text'),
            event_questionnaires: JSON.parse(this.$el.getAttribute('event_questionnaires')),
            use_introducer_tell: this.$el.getAttribute('use_introducer_tell') == 'true',
            use_introducer_name: this.$el.getAttribute('use_introducer_name') == 'true',
            use_introducer_adress: this.$el.getAttribute('use_introducer_adress') == 'true',
            send_csv_path: this.$el.getAttribute('send_csv_path'),
            eventer_mail: this.$el.getAttribute('eventer_mail'),
            edit_audience_path: this.$el.getAttribute('edit_audience_path'),
            recapcha_api_key: this.$el.getAttribute('recapcha_api_key'),
            refund_message: this.$el.getAttribute('refund_message'),
            main_event_play_date: this.$el.getAttribute('main_event_play_date'),
            event_place: this.$el.getAttribute('event_place'),
            event_url: this.$el.getAttribute('event_url'),
            contact_info: this.$el.getAttribute('contact_info'),
            inquiry_url: this.$el.getAttribute('inquiry_url'),
            is_cooperator: this.$el.getAttribute('is_cooperator') == 'true',
            is_can_not_refund_event: this.$el.getAttribute('is_can_not_refund_event') == 'true',
            refund_period: Number(this.$el.getAttribute('refund_period')),
            exclamation_img_path: this.$el.getAttribute('exclamation_img_path'),
            comment_img_path: this.$el.getAttribute('comment_img_path'),
            block_audience_path: this.$el.getAttribute('block_audience_path'),
            send_pdf_path: this.$el.getAttribute('send_pdf_path'),
            use_contact_form: this.$el.getAttribute('use_contact_form') == 'true',
            contact_mails: this.$el.getAttribute('contact_mails'),
            contact_tels: this.$el.getAttribute('contact_tels'),
            contact_urls: this.$el.getAttribute('contact_urls'),
          },
        });
      },
    });
  }

  // 通し券イベントの参加者受付ページ
  if (location.pathname.includes('/audience_list_admission') && !location.pathname.includes('/programs')) {
    new Vue({
      el: '#admission_list_for_multiple_play_date_event-container',
      store,
      template: '<AdmissionListForMultiplePlayDateEvent/>',
      components: { AdmissionListForMultiplePlayDateEvent },
      render: function (createElement) {
        return createElement('AdmissionListForMultiplePlayDateEvent', {
          props: {
            main_event_id: Number(this.$el.getAttribute('main_event_id')),
            main_event_title: String(this.$el.getAttribute('main_event_title')),
            play_dates: JSON.parse(this.$el.getAttribute('play_dates')),
            ticket_types: JSON.parse(this.$el.getAttribute('ticket_types')),
            get_audiences_path: this.$el.getAttribute('get_audiences_path'),
            event_use_introducer: this.$el.getAttribute('event_use_introducer') == 'true',
            event_introducer_text: this.$el.getAttribute('event_introducer_text'),
            event_questionnaires: JSON.parse(this.$el.getAttribute('event_questionnaires')),
            use_introducer_tell: this.$el.getAttribute('use_introducer_tell') == 'true',
            use_introducer_name: this.$el.getAttribute('use_introducer_name') == 'true',
            use_introducer_adress: this.$el.getAttribute('use_introducer_adress') == 'true',
            send_csv_path: this.$el.getAttribute('send_csv_path'),
            send_pdf_path: this.$el.getAttribute('send_pdf_path'),
            eventer_mail: this.$el.getAttribute('eventer_mail'),
            can_action_cable: this.$el.getAttribute('can_action_cable') == 'true',
            admission_accept_path: this.$el.getAttribute('admission_accept_path'),
            admission_unaccept_path: this.$el.getAttribute('admission_unaccept_path'),
            is_assistant_page: this.$el.getAttribute('is_assistant_page')
          },
        });
      },
    });
  }

  // アーティスト別イベント一覧
  if (location.pathname.indexOf('performers/') > 0 && 1 > location.pathname.indexOf('experimental_show')) {
    // イベント一覧
    new Vue({
      el: '#performer-events-show',
      store,
      template: '<PerformerEventsShow/>',
      components: { PerformerEventsShow },
      render: function (createElement) {
        return createElement('PerformerEventsShow', {
          props: {
            get_events_path: this.$el.getAttribute('get_events_path'),
            event_path: this.$el.getAttribute('event_path').substr(0, this.$el.getAttribute('event_path').length - 2) + '/',
          },
        });
      },
    }),
      // フォローボタン
      new Vue({
        el: '#performer-events-follow-show',
        store,
        template: '<PerformerEventsFollowShow/>',
        components: { PerformerEventsFollowShow },
        render: function (createElement) {
          return createElement('PerformerEventsFollowShow', {
            props: {
              uid: Number(this.$el.getAttribute('uid')),
              followable: this.$el.getAttribute('followable') == 'true',
              follow_path: this.$el.getAttribute('follow_path'),
              un_follow_path: this.$el.getAttribute('un_follow_path'),
            },
          });
        },
      });
  }

  // 実験用アーティストページ
  if (location.pathname.indexOf('performers/') > 0 && location.pathname.indexOf('experimental_show') > 0) {
    new Vue({
      el: '#performer-experimental-show',
      store,
      template: '<PerformerExperimentalShow/>',
      components: { PerformerExperimentalShow },
      render: function (createElement) {
        return createElement('PerformerExperimentalShow', {
          props: {
            // ログイン状態 true:ログイン済み false：未ログイン
            is_sign_in: this.$el.getAttribute('is_sign_in') == 'true',
            // 出演者のID
            performer_id: Number(this.$el.getAttribute('performer_id')),
            // 出演者情報取得APIのパス
            show_performers_path: this.$el.getAttribute('show_performers_path'),
            // 出演者の出演するイベント取得APIのパス
            show_performer_events_path: this.$el.getAttribute('show_performer_events_path'),
            // 出演者のフォローAPIのパス
            performer_follow_path: this.$el.getAttribute('performer_follow_path'),
            // 出演者のフォロー解除APIのパス
            performer_un_follow_path: this.$el.getAttribute('performer_un_follow_path'),
            // 出演者のMessage取得APIのパス
            performers_articles_path: this.$el.getAttribute('performers_articles_path'),
            // 出演者のMusic取得APIのパス
            performers_spotify_albums_path: this.$el.getAttribute('performers_spotify_albums_path'),
            // 出演者の記事に対するいいねするAPIのパス
            article_goods_path: this.$el.getAttribute('article_goods_path').replace('/0/', '/###/'),
            // 出演者の記事に対するいいね解除するAPIのパス
            article_un_goods_path: this.$el.getAttribute('article_un_goods_path').replace('/0/', '/###/'),
            // 出演者の記事に対するコメント一覧取得APIのパス
            show_curation_site_article_comments_path: this.$el.getAttribute('show_curation_site_article_comments_path').replace('/0/', '/###/'),
            // 出演者の記事に対するコメントするAPIのパス
            article_comment_post_path: this.$el.getAttribute('article_comment_post_path').replace('/0/', '/###/'),
            // 会員登録画面のパス
            sign_up_path: this.$el.getAttribute('sign_up_path'),
            // 会員情報変更画面のパス
            edit_home_path: this.$el.getAttribute('edit_home_path'),
            // 利用規約・特約画面のパス
            user_policy_path: this.$el.getAttribute('user_policy_path'),
            // イベント詳細画面のパス
            event_path: this.$el.getAttribute('event_path').substr(0, this.$el.getAttribute('event_path').length - 2) + '/',
            // ログイン画面のパス
            sign_in_path: this.$el.getAttribute('sign_in_path'),
            // ルートのURL
            root_url: this.$el.getAttribute('root_url'),
          },
        });
      },
    });
  }

  // ライブ配信ページ
  if (location.pathname.indexOf('live') > 0) {
    // チャット
    new Vue({
      el: '#event-live-chat',
      store,
      template: '<EventLiveChat/>',
      components: { EventLiveChat },
      render: function (createElement) {
        if (this.$el.getAttribute('is_disp_chat_global') == 'true') {
          return createElement('EventLiveChat', {
            props: {
              ttsid: this.$el.getAttribute('ttsid'),
              uimage: this.$el.getAttribute('uimage'),
              uname: this.$el.getAttribute('uname'),
              isorganizer: this.$el.getAttribute('isorganizer') == 'true',
              userid: this.$el.getAttribute('userid'),
            },
          });
        }
      },
    }),
      // 投げ銭
      new Vue({
        el: '#event-live-donation',
        store,
        template: '<EventLiveDonation/>',
        components: { EventLiveDonation },
        render: function (createElement) {
          if (this.$el.getAttribute('is_disp_donation_global') == 'true') {
            return createElement('EventLiveDonation', {
              props: {
                ttsid: this.$el.getAttribute('ttsid'),
                uimage: this.$el.getAttribute('uimage'),
                uname: this.$el.getAttribute('uname'),
                userid: this.$el.getAttribute('userid'),
                stkey: this.$el.getAttribute('stkey'),
                donation_api_path: this.$el.getAttribute('donation_api_path'),
                card_number: this.$el.getAttribute('card_number'),
                exp_date: this.$el.getAttribute('exp_date'),
                cvc: this.$el.getAttribute('cvc'),
                performers: JSON.parse(this.$el.getAttribute('performers')),
                event_name: this.$el.getAttribute('event_name'),
                event_path: this.$el.getAttribute('event_path'),
                use_existing_card: this.$el.getAttribute('use_existing_card') == 'true',
                stripe_font_color: this.$el.getAttribute('stripe_font_color'),
                contact_link: this.$el.getAttribute('contact_link'),
              },
            });
          }
        },
      }),
      // 投げ銭アイテム一覧
      new Vue({
        el: '#event-live-donation-item-list',
        store,
        template: '<EventLiveDonationItemList/>',
        components: { EventLiveDonationItemList },
        render: function (createElement) {
          const currentUserAttr = this.$el.getAttribute('current_user');
          const currentUser = currentUserAttr === 'true';
          if (this.$el.getAttribute('is_disp_donation_global') == 'true') {
            return createElement('EventLiveDonationItemList', {
              props: {
                get_skus_path: this.$el.getAttribute('get_skus_path'),
                new_user_session_path: this.$el.getAttribute('new_user_session_path'),
                current_user: currentUser,
              },
            });
          }
        },
      }),
      // 投げ銭されたもの一覧
      new Vue({
        el: '#event-live-donated-item-list',
        store,
        template: '<EventLiveDonatedItemList/>',
        components: { EventLiveDonatedItemList },
        render: function (createElement) {
          if (this.$el.getAttribute('is_disp_donation_global') == 'true') {
            return createElement('EventLiveDonatedItemList', {
              props: {
                ttsid: this.$el.getAttribute('ttsid'),
              },
            });
          }
        },
      }),
      // 中断幕(フィラー)ON/OFFボタン
      new Vue({
        el: '#event-live-curtain-button',
        store,
        template: '<EventLiveCurtainButton/>',
        components: { EventLiveCurtainButton },
        render: function (createElement) {
          if (this.$el.getAttribute('isorganizer') == 'true') {
            return createElement('EventLiveCurtainButton', {
              props: {
                ttsid: this.$el.getAttribute('ttsid'),
              },
            });
          }
        },
      }),
      // 中断幕(フィラー)
      new Vue({
        el: '#event-live-curtain',
        store,
        template: '<EventLiveCurtain/>',
        components: { EventLiveCurtain },
        render: function (createElement) {
          return createElement('EventLiveCurtain', {
            props: {
              ttsid: this.$el.getAttribute('ttsid'),
              isorganizer: this.$el.getAttribute('isorganizer') == 'true',
              is_fvlive: this.$el.getAttribute('is_fvlive') == 'true',
            },
          });
        },
      }),
      // 主催者メッセージ一覧
      new Vue({
        el: '#event-live-eventer-message-list',
        store,
        template: '<EventLiveEventerMessageList/>',
        components: { EventLiveEventerMessageList },
        render: function (createElement) {
          return createElement('EventLiveEventerMessageList', {
            props: {
              ttsid: this.$el.getAttribute('ttsid'),
              isorganizer: this.$el.getAttribute('isorganizer') == 'true',
            },
          });
        },
      }),
      // 主催者メッセージのフォーム
      new Vue({
        el: '#event-live-eventer-message-form',
        store,
        template: '<EventLiveEventerMessageForm/>',
        components: { EventLiveEventerMessageForm },
        render: function (createElement) {
          if (this.$el.getAttribute('isorganizer') == 'true') {
            return createElement('EventLiveEventerMessageForm', {
              props: {
                ttsid: this.$el.getAttribute('ttsid'),
                uimage: this.$el.getAttribute('uimage'),
                uname: this.$el.getAttribute('uname'),
                uid: this.$el.getAttribute('uid'),
              },
            });
          }
        },
      }),
      // 多重視聴制限のフォーム
      new Vue({
        el: '#event-live-muptiple-viewing',
        store,
        template: '<EventLiveMuptipleViewing/>',
        components: { EventLiveMuptipleViewing },
        render: function (createElement) {
          if (this.$el.getAttribute('is_disp_multiple_viewing_global') == 'false' && this.$el.getAttribute('uid').length > 0 && this.$el.getAttribute('isorganizer') == 'false' && this.$el.getAttribute('isonlyviewing') == 'false') {
            return createElement('EventLiveMuptipleViewing', {
              props: {
                ttsid: this.$el.getAttribute('ttsid'),
                uid: this.$el.getAttribute('uid'),
                is_disp_multiple_viewing_global: this.$el.getAttribute('is_disp_multiple_viewing_global') == 'true',
                event_page_url: this.$el.getAttribute('event_page_url'),
              },
            });
          }
        },
      });
  }
});
